import { useWatch } from 'react-hook-form';
import { Body1 } from 'ui/theme';
import { lowerCaseMessageMedium } from 'modules/frequencyManagement/lib/utils/mediumDomainUtils';
import { FrequencyPeriod, SupportedMediums } from 'modules/frequencyManagement/lib/types';
import { LABEL_BY_PERIOD } from '../../lib/constants';
import { CAPPING_MAX_ALLOWED, CAPPING_PERIOD } from '../../contexts/FormProvider';
import { FixedCap } from '../fixedCap/FixedCap';
import { SummaryInset } from '../summaryInset/SummaryInset';

export const FixedCapSection = ({
  isEditing,
  messageMedium,
}: {
  isEditing: boolean;
  messageMedium: SupportedMediums;
}) => {
  const maxAllowed = useWatch({ name: CAPPING_MAX_ALLOWED });
  const period = useWatch({ name: CAPPING_PERIOD }) as FrequencyPeriod;

  return isEditing ? (
    <FixedCap messageMedium={messageMedium} />
  ) : (
    <SummaryInset>
      <Body1>
        Send no more than{' '}
        <b>
          {maxAllowed} {lowerCaseMessageMedium(messageMedium)} messages per{' '}
          {LABEL_BY_PERIOD[period]}
        </b>{' '}
        per user.
      </Body1>
    </SummaryInset>
  );
};
